import { NodeViewContent, NodeViewWrapper, type ReactNodeViewProps, useEditorState } from "@tiptap/react";

export function KvPairView({ node, editor, updateAttributes }: ReactNodeViewProps) {
  const editable = useEditorState({ editor, selector: ({ editor: e }) => e.isEditable });
  const key = String(node.attrs.key ?? "");
  return (
    <NodeViewWrapper className="kd-kv__pair">
      {editable ? (
        <input
          className="kd-kv__key-input"
          contentEditable={false}
          aria-label="Key"
          placeholder="Key"
          value={key}
          onChange={(e) => {
            if (editor.isEditable) updateAttributes({ key: e.target.value });
          }}
        />
      ) : (
        <span className="kd-kv__key" contentEditable={false}>{`${key}:`}</span>
      )}
      <NodeViewContent className="kd-kv__value" />
    </NodeViewWrapper>
  );
}
